var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTikTok = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  viewBox: "0 0 32 32"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2586_70034)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  fill: "#1A121F",
  rx: 16
}), /*#__PURE__*/React.createElement("path", {
  fill: "#26F4EE",
  fillRule: "evenodd",
  d: "M19.211 6.782c.297 2.535 1.816 4.323 4.273 4.48v2.405l-.016.002v-2.043c-2.457-.157-3.87-1.669-4.166-4.204h-2.603v10.665c.375 4.8-3.365 4.943-4.796 3.123 1.678 1.05 4.403.367 4.08-3.764V6.782zm-6.993 17.68c-1.471-.303-2.808-1.182-3.594-2.467-1.908-3.121-.188-8.209 5.346-8.733l-.009.753c-5.13.817-5.645 6.328-4.225 8.62.548.885 1.448 1.506 2.481 1.826",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FB2C53",
  fillRule: "evenodd",
  d: "M19.957 7.582c.17 1.444.7 2.7 1.58 3.543-1.235-.639-1.98-1.854-2.214-3.543zm3.512 4.562q.315.066.655.089v2.85c-1.425.14-2.673-.329-4.126-1.203l.223 4.881c0 1.574.006 2.294-.839 3.742-2.058 3.529-5.906 3.527-8.183 1.518 2.97 1.705 8.153.37 8.144-5.42v-5.327c1.453.874 2.7 1.343 4.126 1.203zm-9.508 2.06a9 9 0 0 1 .94-.141v3.005c-1.198.198-1.959.566-2.315 1.247-1.002 1.916.046 3.478 1.433 3.97-1.735-.062-3.457-1.844-2.261-4.13.356-.68 1.005-1.049 2.204-1.246z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  fillRule: "evenodd",
  d: "M19.302 7.422c.297 2.535 1.71 4.047 4.167 4.204v2.85c-1.426.14-2.673-.328-4.126-1.203v5.328c.01 6.954-7.47 7.483-9.606 4.034-1.421-2.292-.906-7.803 4.224-8.62v2.894c-1.198.197-1.848.565-2.204 1.246-2.199 4.205 5.472 6.707 4.942-.068V7.422z",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2586_70034"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h32v32H0z"
})))));
export default SvgTikTok;